import { MouseEvent, useState } from 'react';

type UseMenuOptions = {
  stopPropagation?: boolean;
};

export const useMenu = ({ stopPropagation = false }: UseMenuOptions = {}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const open = (event: MouseEvent<HTMLElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    setAnchorEl(event.currentTarget);
  };

  const close = () => {
    setAnchorEl(null);
  };

  const runAction = (event: MouseEvent, action: () => void) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    setAnchorEl(null);
    action();
  };

  const stopEventPropagation = (event: MouseEvent) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
  };

  return { anchorEl, isOpen, open, close, runAction, stopEventPropagation };
};
